var config;

//Load env config file from root of server
// For local dev, this should grab the envconfig.json defined in the source project.
// For a release, the infra build will insert the appropriate envconfig.json file
//  when it builds/synths.
async function getConfig() {
    if (!config) {
        config = await fetch('envconfig.json', {
            mode: 'no-cors'
        }).then(response => response.json());
    }
    return config;
}
export {
    getConfig
};



// WEBPACK FOOTER //
// ./src/envconfig.js